<template>
  <div class="stepper-box">
    <div class="top">
      <div class="steps-wrapper">
        <template v-for="(step, index) in steps">
          <div :class="['step', isStepActive(index, step)]">
            <div class="circle">
              <i class="material-icons md-18">
                {{ (step.completed) ? 'done' : step.icon }}
              </i>
            </div>
            <div class="step-title">
              <span>{{ step.title }}</span>
            </div>
          </div>
          <div v-if="index < (steps.length - 1)" class="divider-line"></div>
        </template>
      </div>
    </div>

    <div class="content mt-4">
      <transition
        :enter-active-class="enterAnimation"
        :leave-active-class="leaveAnimation"
        mode="out-in"
      >
        <component
          :is="steps[currentStep.index].component"
          v-bind="oggetto"
          :content="steps[currentStep.index].content"
          :is_active="true"
          @next-step="nextStep"
          @closemodal="$emit('closemodal')"
        ></component>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "HorizontalStepperPad",

  props: {
    oggetto: {
      required: true
    },

    steps: {
      type: Array,
      required: true
    },
  },

  data () {
    return {
      currentStep: {},
      previousStep: {},
      nextButton: {},
      finalStep: false,
      keepAliveData: this.keepAlive
    };
  },

  computed: {
    enterAnimation () {
      if (this.currentStep.index < this.previousStep.index) {
        return "animated quick fadeInLeft";
      } else {
        return "animated quick fadeInRight";
      }
    },
    leaveAnimation () {
      if (this.currentStep.index > this.previousStep.index) {
        return "animated quick fadeOutLeft";
      } else {
        return "animated quick fadeOutRight";
      }
    }
  },

  methods: {
    isStepActive (index, step) {
      if (this.currentStep.index === index) {
        return "activated";
      } else {
        return "deactivated";
      }
    },

    activateStep (index, back = false) {
      if (this.steps[index]) {
        this.previousStep = this.currentStep;
        this.currentStep = {
          name: this.steps[index].name,
          index: index
        };

        if (index + 1 === this.steps.length) {
          this.finalStep = true;
        } else {
          this.finalStep = false;
        }

        if (!back) {
          this.$emit("completed-step", this.previousStep);
        }
      }
      this.$emit("active-step", this.currentStep);
    },

    nextStep () {
        this.$emit("stepper-finished", this.currentStep, this.finalStep);
        let currentIndex = this.currentStep.index + 1;

        this.activateStep(currentIndex);
    },

    backStep () {
      this.$emit("clicking-back");
      let currentIndex = this.currentStep.index - 1;
      if (currentIndex >= 0) {
        this.activateStep(currentIndex, true);
      }
    },

    init () {
      this.activateStep(0);
    },
  },

  created () {
    this.init();
  }
};
</script>

<style scoped lang="scss">
@mixin shadow($level: 1) {
  @if $level==1 {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  }

  @else if $level==2 {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  }

  @else if $level==3 {
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  }

  @else if $level==4 {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  }

  @else if $level==5 {
    box-shadow: 0 19px 38px rgba(0, 0, 0, 0.30), 0 15px 12px rgba(0, 0, 0, 0.22);
  }
}

@mixin breakpoint($class) {
  @if $class==xs {
    @media (max-width: 767px) {
      @content;
    }
  }

  @else if $class==sm {
    @media (min-width: 768px) {
      @content;
    }
  }

  @else if $class==md {
    @media (min-width: 992px) {
      @content;
    }
  }

  @else if $class==lg {
    @media (min-width: 1200px) {
      @content;
    }
  }

  @else {
    @warn "Breakpoint mixin supports: xs, sm, md, lg";
  }
}

.stepper-box {
  background-color: white;
  @include shadow(1);
  min-height: 200px;

  .top {
    .stepper-button-top {
      z-index: 20;
      padding: .4rem;
      border-radius: 100rem;
      cursor: pointer;
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: space-between;

      &.next {
        border: 2px solid var(--primary);
        color: var(--primary);
        right: 1%;

        &.deactivated {
          border: 2px solid #cccccc !important;
          color: #cccccc;
          cursor: not-allowed !important;
        }
      }

      &.previous {
        color: white;
        left: 1%;
      }
    }

    display: flex;
    align-items: center;
    position: relative;
    justify-content: center;

    .divider-line {
      border-bottom: 1px solid #cccccc;
      height: 2px;
      flex-grow: 1;
      margin-bottom: 16px;
    }

    .steps-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      width: 95%;
      left: 0;
      padding: 2% 40px;

      @include breakpoint(xs) {
        width: 90%;
        justify-content: center;
      }

      .step {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        padding: 0px;

        @include breakpoint(xs) {
          width: 100% !important;
        }

        &.deactivated {
          @include breakpoint(xs) {
            display: none;
          }

          .circle {
            i {
              background-color: #bbbbbb !important;
            }
          }

          .step-title {
            opacity: .35;
          }
        }

        .circle {
          margin-bottom: 1rem;
          padding: 0 1rem;
          background-color: white;

          i {
            background-color: var(--primary);
            color: #fff;
            border-radius: 100rem;
            padding: 1.5rem;
          }
        }

        .step-title {
          position: relative;

          span {
            display: block;
            position: absolute;
            color: #000;
            font-size: 0.9rem;
            font-weight: 600;
            text-align: center;
            width: 200px;
            left: -100px;
          }
        }
      }
    }
  }

  .content {
    overflow: hidden;
    margin: 1.5rem 0;
    padding-top: 3.5rem;
  }

  .bottom {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2rem;
    border-top: 1px solid #cccccc;

    &.only-next {
      justify-content: flex-end;
    }

    .stepper-button {
      padding: .5rem 1rem;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: var(--primary);
      color: white;
      @include shadow(1);

      &.deactivated {
        background-color: #cccccc;
        cursor: not-allowed !important;
      }

      span {
        color: white;
      }
    }
  }
}
</style>
<style scoped>
</style>